import request, { METHODS } from "src/utils/api-base";

const supportRequestApis = {
  createSupportRequest: (payload: {
    name: string;
    email: string;
    mobile: string;
    message: string;
  }) => {
    return request({
      route: "/app/support-request/create",
      method: METHODS.POST,
      payload,
    });
  },
  raiseSupportRequest: (payload: { subject?: string; message: string }) => {
    return request({
      route: "/app/support-request/raise",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },
  raiseSupportRequestAdmin: (payload: {
    tenantId?: string;
    subject?: string;
    message: string;
  }) => {
    return request({
      route: "/admin/support-request/admin-raise",
      method: METHODS.POST,
      payload,
      auth: true,
      isAdminAuth: true,
    });
  },
  getSupportRequestsListAdmin: (params: {
    page: number;
    limit: number;
    status?: string;
    search?: string;
  }) => {
    return request({
      route: "/admin/support-request/list",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    });
  },
  getSupportRequestsListTenant: (params: {
    page: number;
    limit: number;
    status?: string;
    search?: string;
  }) => {
    return request({
      route: "/app/support-request/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },
  getSupportRequestByIdAdmin: (_id: string) => {
    return request({
      route: `/admin/support-request/${_id}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    });
  },
  getSupportRequestByIdTenant: (_id: string) => {
    return request({
      route: `/app/support-request/${_id}`,
      method: METHODS.GET,
      auth: true,
    });
  },
  replySupportRequestAdmin: (payload: { _id: string; message: string }) => {
    const { _id, message } = payload;
    return request({
      route: `/admin/support-request/${_id}/reply`,
      method: METHODS.POST,
      payload: { message },
      auth: true,
      isAdminAuth: true,
    });
  },
  replySupportRequestTenant: (payload: { _id: string; message: string }) => {
    const { _id, message } = payload;
    return request({
      route: `/app/support-request/${_id}/reply`,
      method: METHODS.POST,
      payload: { message },
      auth: true,
    });
  },
  updateSupportRequestStatusAdmin: (payload: {
    _id: string;
    status: string;
  }) => {
    const { _id, status } = payload;
    return request({
      route: `/admin/support-request/${_id}/status`,
      method: METHODS.PATCH,
      payload: { status },
      auth: true,
      isAdminAuth: true,
    });
  },
};

export default supportRequestApis;
